import React from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'sa-ui';
import { FormattedMessage, injectIntl } from 'react-intl';
import messages from './simulatedQuestionsMessages';

const FinishValidationConfirmModal = props => (
  <Modal
    show={props.show}
    onClose={props.onClose}
    icon="ti-thumb-up"
    title={<FormattedMessage {...messages.finishValidation} />}
    message={<FormattedMessage {...messages.finishValidationText} />}
    buttons={[
      {
        label: <FormattedMessage {...messages.cancel} />,
        onClick: props.onClose,
      },
      {
        label: <FormattedMessage {...messages.proceed} />,
        onClick: props.onContinue,
        primary: true,
      },
    ]}
  />
);

FinishValidationConfirmModal.propTypes = {};

export default FinishValidationConfirmModal;
